import { render, staticRenderFns } from "./StaffManage.vue?vue&type=template&id=4352cde0&"
import script from "./StaffManage.vue?vue&type=script&lang=js&"
export * from "./StaffManage.vue?vue&type=script&lang=js&"
import style0 from "./StaffManage.vue?vue&type=style&index=0&id=4352cde0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports